module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.f1700587.WOFF";